import { useNavigate } from 'react-router-dom'
import { Home } from 'lucide-react'
import Button from '../components/ui/Button'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-surface-container-low flex flex-col items-center justify-center px-6 text-center">
      <p className="text-7xl font-bold font-mono text-outline-variant mb-6">404</p>
      <h1 className="text-xl font-semibold tracking-[0.05em] text-on-surface mb-2">Page Not Found</h1>
      <p className="text-sm text-on-surface-variant mb-8">The page you're looking for doesn't exist.</p>
      <Button onClick={() => navigate('/')}>
        <Home size={16} />
        Back Home
      </Button>
    </div>
  )
}
